// extracted by mini-css-extract-plugin
module.exports = {"horiNav":"services_nav_horiNav__1H6l1","aside":"services_nav_aside__34zl2","vertNav":"services_nav_vertNav__3Wnz3"};